export default __webpack_public_path__ + "19a5c552a0365b83ca982049d31a43f2.png";